<div #mapContainer
     (click)="$event.stopPropagation()"
     class="map-container">
</div>
@if (isDeviceDetailOpen) {
  <app-dialog-base (click)="closeShowDetails()"
                   [buttonAction]="closeShowDetails"
                   [class.open]="isDeviceDetailOpen"
                   [title]="selectedDevice ? `${'common.action.view-device' | translateSafe} ${selectedDevice.serial_number}` : ''"
                   iconLeft="info">
    <app-dialog-device-detail #showDeviceDetails
                              [device]="selectedDevice"/>
  </app-dialog-base>

}
